var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2Childroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM27.26 23a8 8 0 00-4 14.84 16 16 0 1029.52 0 8.001 8.001 0 00-6.16-14.644 8 8 0 00-5.38 5.144 16.36 16.36 0 00-6.44 0A8 8 0 0027.26 23zm-2 11.38A4 4 0 1131 29.63a16.08 16.08 0 00-5.75 4.73l.01.02zM30 37.44a2 2 0 114 0 2 2 0 01-4 0zM48.74 27a4 4 0 012 7.38A16.08 16.08 0 0045 29.63 4 4 0 0148.74 27zm-4.66 8.46a2 2 0 11-2 2 2 2 0 012-2.02v.02zM45 48.85a7 7 0 11-14 0 7 7 0 0114 0zM35 47a3 3 0 115.999 0A3 3 0 0135 47z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Childroom.1795b603.svg";
export { SvgE2Childroom as ReactComponent };